import { render } from "./MyLayout.vue?vue&type=template&id=3b8bad10&scoped=true"
import script from "./MyLayout.vue?vue&type=script&lang=js"
export * from "./MyLayout.vue?vue&type=script&lang=js"

import "./MyLayout.vue?vue&type=style&index=0&id=3b8bad10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b8bad10"]])

export default __exports__